/***
 * Created on 2023/7/11
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../service/api";
import {useTranslation} from "react-i18next";

function Country(props) {
    const [showMenu, setShowMenu] = useState('');
    const [selectMenu, setSelectMenu] = useState(props.initValue || '');
    const inputRef = useRef();
    const { t } = useTranslation();

    const query = useQuery({
        queryKey: ['country_code'],
        queryFn: async () => await apiGet('/ajax/country_code'),
        staleTime: 60 * 60 * 1000   // re-fetch the data in 1 hour
    })

    const hideMenuHandler = (e) => {
        if (inputRef.current && !inputRef.current.contains(e.target)) {
            setShowMenu('');
        }
    }

    const toggleDropdown = (e) => {
        setShowMenu(prev => {
            return (prev === 'active') ? '' : 'active';
        });
    }

    const onClick = (e, country) => {
        setSelectMenu(country);
        if (props.onClick) {
            props.onClick(e, null, 'country', country);
        }
    }

    const display_country = useMemo(() => {
        if (selectMenu) {
            return t(`@${selectMenu}@`);
        }
        else if (props.initValue) {
            return t(`@${props.initValue}@`)
        }
        return ""

    }, [selectMenu, props.initValue]);

    useEffect(() => {
        window.addEventListener('click', hideMenuHandler);

        return () => {
            window.removeEventListener('click', hideMenuHandler);
        }
    });

    return (
        <div className="form-group">
            <label>{t('@Country@')}</label>
            <div className={`comp-select ${showMenu}`} onClick={toggleDropdown} ref={inputRef}>
                <div className="q-select cursor-pointer">
                    <div className="q-select__label">{display_country}</div>
                    <div className="q-select__arrow"></div>
                </div>
                <div className="comp-dropdown" data-modal-sheet>
                    <ul className="dropdown-menu">
                        {
                            query?.data?.map(country => (
                                <li className="dropdown-menu__item cursor-pointer" key={country.country} onClick={e=>onClick(e, country.country)}>{t(`@${country.country}@`)}</li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Country;